
import { jwtDecode } from 'jwt-decode';
import apiClient from '../acciones/apiClient';

export const UPLOAD_SLIDER_REQUEST = 'UPLOAD_SLIDER_REQUEST';
export const UPLOAD_SLIDER_SUCCESS = 'UPLOAD_SLIDER_SUCCESS';
export const UPLOAD_SLIDER_FAILURE = 'UPLOAD_SLIDER_FAILURE';
export const GET_SLIDERS = 'GET_SLIDERS';
export const DELETE_SLIDER = 'DELETE_SLIDER';
export const GET_PROYECTOS = 'GET_PROYECTOS';
export const UPLOAD_NOTIFICATION_REQUEST = 'UPLOAD_NOTIFICATION_REQUEST';
export const UPLOAD_NOTIFICATION_SUCCESS = 'UPLOAD_NOTIFICATION_SUCCESS';
export const UPLOAD_NOTIFICATION_FAILURE = 'UPLOAD_NOTIFICATION_FAILURE';
export const GET_LATEST_MANHWAS = 'GET_LATEST_MANHWAS';
export const FETCH_PROYECTOS_PAGINATED_SUCCESS = 'FETCH_PROYECTOS_PAGINATED_SUCCESS';
export const FETCH_PROYECTOS_PAGINATED_ERROR = 'FETCH_PROYECTOS_PAGINATED_ERROR';
export const GET_NOTIFICACIONES = 'GET_NOTIFICACIONES';
export const GET_LAST_NOTIFICATION = 'GET_LAST_NOTIFICATION';
export const GET_POPULAR_SERIES = 'GET_POPULAR_SERIES';
export const GET_AFILIADOS = 'GET_AFILIADOS';
export const GET_COMENTARIOS = 'GET_COMENTARIOS';
export const DELETE_COMENTARIOS_PROYECTOS = 'DELETE_COMENTARIOS_PROYECTOS';

export const getUsuarios = () => {
    return async (dispatch) => {
        try {
            const dataUsuarios = await apiClient.get("/usuarios");
            return dispatch({
                type: 'GET_USUARIOS',
                payload: dataUsuarios.data
            });
        } catch (error) {
            console.log(error);
        }
    };
};

export const updateUsuarioRango = (userId, nuevoRango) => {
    return async (dispatch) => {
        try {
            const response = await apiClient.put(`/usuarios/${userId}`, { rango: nuevoRango });
            return dispatch({
                type: 'UPDATE_USUARIO_RANGO',
                payload: response.data
            });
        } catch (error) {
            console.log(error);
        }
    };
};


export const register = (userData) => async (dispatch) => {
    try {
        await apiClient.post('/auth/register', userData);
        dispatch({ type: 'REGISTER_SUCCESS' });
    } catch (error) {
        dispatch({ type: 'REGISTER_FAILURE', payload: error.response.data });
    }
};

export const login = (userData) => async (dispatch) => {
    try {
        const response = await apiClient.post('/auth/login', userData);
        const token = response.data.token;

        // Decodifica el token para obtener la información del usuario
        const decodedToken = jwtDecode(token);

        localStorage.setItem('token', token);

        dispatch({
            type: 'LOGIN_SUCCESS',
            payload: {
                user: decodedToken,
                token
            }
        });
    } catch (error) {
        dispatch({ type: 'LOGIN_FAILURE', payload: error.response.data });
    }
};

export const uploadSlider = (title, info, image) => async (dispatch) => {
    dispatch({ type: UPLOAD_SLIDER_REQUEST });

    const formData = new FormData();
    formData.append('title', title);
    formData.append('info', info);

    if (image) {
        const response = await fetch(image);
        const blob = await response.blob();
        formData.append('image', blob, 'slider-image.webp');
    }

    try {
        const response = await apiClient.post('/upload-slider', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        dispatch({ type: UPLOAD_SLIDER_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: UPLOAD_SLIDER_FAILURE, payload: error.response ? error.response.data : error.message });
    }
};

export const getSliders = () => async (dispatch) => {
    try {
        const response = await apiClient.get('/slider');
        dispatch({
            type: GET_SLIDERS,
            payload: response.data,
        });
    } catch (error) {
        console.error('Error al obtener sliders:', error);
    }
};


export const deleteSlider = (id) => async (dispatch) => {
    try {
        await apiClient.delete(`/slider/${id}`);
        dispatch({ type: DELETE_SLIDER, payload: id });
    } catch (error) {
        console.log(error);
    }
};

export const getProyectos = (page = 1, limit = 10) => async (dispatch) => {
  try {
    const response = await apiClient.get(`/proyectos?page=${page}&limit=${limit}`);
    console.log("getProyectos DATA:", response.data);
    dispatch({
      type: GET_PROYECTOS,
      payload: response.data
    });
  } catch (error) {
    console.error('Error al obtener proyectos:', error);
  }
};


export const addPopularSeries = (data) => async (dispatch) => {
    try {
        const response = await apiClient.post('/api/popular-series', data);
        dispatch({
            type: 'ADD_POPULAR_SERIES',
            payload: response.data,
        });
    } catch (error) {
        console.error('Error al agregar la serie popular:', error);
    }
};

export const getPopularSeries = () => async (dispatch) => {
    try {
        const response = await apiClient.get('/popular-series'); // Ajusta la URL si es diferente
        dispatch({
            type: GET_POPULAR_SERIES,
            payload: response.data, // Asegúrate de que el backend envía `{ hoy, semana, todos }`
        });
    } catch (error) {
        console.error('Error al obtener las series populares:', error);
    }
};




export const crearNotificacion = (imagen, titulo, descripcion) => async (dispatch) => {
    dispatch({ type: UPLOAD_NOTIFICATION_REQUEST });

    const formData = new FormData();
    formData.append('imgNotifi', imagen);
    formData.append('titulo', titulo);
    formData.append('descripcion', descripcion);

    try {
        const response = await apiClient.post('/notificaciones', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        dispatch({ type: UPLOAD_NOTIFICATION_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({
            type: UPLOAD_NOTIFICATION_FAILURE,
            payload: error.response ? error.response.data : error.message,
        });
    }
};

// En acciones/index.js
export const getLatestManhwas = (userId) => async (dispatch) => {
    try {
        //const response = await apiClient.get('/proyectos/latest');
        const response = await apiClient.get('/proyectos/latest', {
            params: { userId }
        });
        dispatch({
            type: 'GET_LATEST_MANHWAS',
            payload: response.data,
        });
    } catch (error) {
        console.error('Error al obtener los últimos proyectos:', error);
    }
};



export const fetchProyectosPaginated = (page = 1) => {
    return async (dispatch) => {
        try {
            const response = await apiClient.get(`/proyectos/paginated?page=${page}`);
            console.log("Response:", response);
            dispatch({
                type: FETCH_PROYECTOS_PAGINATED_SUCCESS,
                payload: response.data, // Asegúrate de que los datos sean correctos
            });
        } catch (error) {
            dispatch({
                type: FETCH_PROYECTOS_PAGINATED_ERROR,
                payload: error.message,
            });
        }
    };
};

export const getNotificaciones = () => {
    return async (dispatch) => {
        try {
            console.log('Ejecutando getNotificaciones'); // Verificar que se llama
            const response = await apiClient.get('/notificaciones');
            console.log('Respuesta de la API:', response.data); // Verificar la respuesta
            dispatch({
                type: GET_NOTIFICACIONES,
                payload: response.data,
            });
        } catch (error) {
            console.error('Error al obtener las notificaciones:', error);
        }
    };
};


export const getLastNotification = () => async (dispatch) => {
    try {
        const response = await apiClient.get('/notificaciones/ultima');
        dispatch({
            type: GET_LAST_NOTIFICATION,
            payload: response.data,
        });
    } catch (error) {
        console.error('Error al obtener la última notificación:', error);
    }
};

export const getAfiliados = () => async (dispatch) => {
    try {
        const response = await apiClient.get('/usuarios/afiliados');
        console.log(response.data); // Verifica que los datos incluyan `user_id`
        dispatch({
            type: GET_AFILIADOS,
            payload: response.data,
        });
    } catch (error) {
        console.error('Error al obtener afiliados:', error);
    }
};


export const getUsuarioPerfil = (id) => async (dispatch) => {
    try {
        const response = await apiClient.get(`/usuarios/perfil/${id}`); // Cambiado a ID
        dispatch({
            type: 'GET_USUARIO_PERFIL',
            payload: response.data,
        });
    } catch (error) {
        console.error("Error al obtener el perfil:", error);
    }
};

export const getComentariosTotal = () => async (dispatch) => {
    try {
        const response = await apiClient.get('/comentarios/total'); // Ajusta la URL según tu API
        dispatch({
            type: GET_COMENTARIOS,
            payload: response.data
        });
    } catch (error) {
        console.error('Error al obtener comentarios:', error);
    }
};





